import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import store from '../../../store';

@customElement('avanza-specsheet')
export class AvanzaSpecsheet extends connect(store)(LitElement) {

	static styles = [
		css`
		  :host {
			font-family: var(--font-family-light);
		  }
		`
	];
	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
	}

	render() {
		return html`
		<specsheet-page>
			<avanza-page-summary></avanza-page-summary>
		</specsheet-page>
		<specsheet-page>
			<avanza-page-data-and-text></avanza-page-data-and-text>
		</specsheet-page>
		`;
	}
}
